import Model, { attr, belongsTo } from '@warp-drive/legacy/model';
import { Type } from '@warp-drive/core-types/symbols';
import type CompanyModel from './company.ts';

export default class TasUnaccreditedInstitutionModel extends Model {
  @attr declare address: string;
  @attr declare locationName: string;
  @attr declare locationType: string;

  @belongsTo('company', { async: false, inverse: null })
  declare company: CompanyModel;

  [Type] = 'tas-unaccredited-institution' as const;
}
